import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import ElementUI from 'element-ui'
import store from '@/store'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/reset.css'
import '@/styles/media.css'
import '@/styles/index.css'
import _ from 'lodash'

import copy from '@/directives/copy'
import './assets/iconfont/iconfont.css'
import './utils/getDeviceId'
// import '@/styles/rem.js'
Vue.config.productionTip = false

Vue.use(ElementUI)

import { message } from '@/utils/messageOnce'
Vue.prototype.$message = message
Vue.prototype.$_ = _
Vue.directive('copy', copy)

new Vue({
    render: (h) => h(App),
    router,
    store,
}).$mount('#app')
